const geturl=(URL)=>{
    let timestamp=new Date().getTime();
    let device='PC'
    return URL+'?device=PC&timestamp='+timestamp
}
export default geturl;



// WEBPACK FOOTER //
// ./src/api/seturl.js